import React, { Component } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";
import { Button } from "arv-reactcomponents";

@inject("CommonStore", "LoginStore", "MybagStore")
@observer
class MobileAction extends Component {
  constructor(props) {
    super(props);
    this.onLogin = this.onLogin.bind(this);
    this.logout = this.logout.bind(this);
    this.reset = this.reset.bind(this);
  }

  onLogin() {
    this.props.LoginStore.setloginModal(true);
  }

  get getClassName() {
    return this.props.CommonStore.isBrandPage
      ? "nw-mobileaction-brand-span"
      : "nw-mobileaction-header-span";
  }
  get hideForBrand() {
    return (
      (this.props.CommonStore.isBrandPage &&
        this.props.class === "nw-nnnow-header" &&
        "nwc-hide") ||
      ""
    );
  }
  get isAccount() {
    return this.props.LoginStore.isUserLoggedIn ? "" : "nwc-hide";
  }

  logout() {
    this.props.LoginStore.logoutAction();
    this.props.MybagStore.clearCart();
  }
  reset() {
    this.props.reset();
  }

  render() {
    return (
      <li>
        <ul className={`nw-mobileaction-list ${this.hideForBrand}`}>
          <li
            className={`nw-mobileaction-links nw-mobileaction-account ${
              this.isAccount
            }`}
          >
            <a href="/account">
              <Button className="nw-mobileaction-button">
                <i className="icomoon-person1 nw-mobileaction-icon" />
                <span className={`nw-mobileaction-text ${this.getClassName}`}>
                  {" "}
                  MY ACCOUNT{" "}
                </span>
              </Button>
            </a>
          </li>
          <li className={`nw-mobileaction-links ${this.isAccount}`}>
            <a href="/favorites">
              <Button className="nw-mobileaction-button">
                <i className="icomoon-heart-o nw-mobileaction-icon" />
                <span className={`nw-mobileaction-text ${this.getClassName}`}>
                  {" "}
                  MY FAVORITES{" "}
                </span>
              </Button>
            </a>
          </li>
          <li className="nw-mobileaction-links">
            {this.props.LoginStore.isUserLoggedIn ? (
              <Button className="nw-mobileaction-button" onClick={this.logout}>
                <i className="icomoon-sign-out nw-mobileaction-icon" />
                <span className={`nw-mobileaction-text ${this.getClassName}`}>
                  {" "}
                  SIGN OUT{" "}
                </span>
              </Button>
            ) : (
              <Button
                className="nw-mobileaction-button"
                onClick={this.onLogin}
                onKeyPress={this.onLogin}
              >
                <i className="icomoon-person1 nw-mobileaction-icon" />
                <span className={`nw-mobileaction-text ${this.getClassName}`}>
                  {" "}
                  LOGIN{" "}
                </span>
              </Button>
            )}
          </li>
          <li className="nw-mobileaction-links">
            <Link href="/store-locator" to="/store-locator" target="_self">
              <Button className="nw-mobileaction-button" onClick={this.reset}>
                <i className="icomoon-marker3 nw-mobileaction-icon" />
                <span className={`nw-mobileaction-text ${this.getClassName}`}>
                  {" "}
                  STORE LOCATOR{" "}
                </span>
              </Button>
            </Link>
          </li>
          <li className="nw-mobileaction-links">
            <a href="/contactus">
              <Button className="nw-mobileaction-button">
                <i className="icomoon-phone nw-mobileaction-icon" />
                <span className={`nw-mobileaction-text ${this.getClassName}`}>
                  {" "}
                  CONTACT US{" "}
                </span>
              </Button>
            </a>
          </li>
        </ul>
      </li>
    );
  }
}

MobileAction.defaultProps = {
  class: "",
};

MobileAction.wrappedComponent.propTypes = {
  reset: PropTypes.func.isRequired,
  MybagStore: PropTypes.shape({
    clearCart: PropTypes.func.isRequired,
  }).isRequired,
  CommonStore: PropTypes.shape({
    isBrandPage: PropTypes.bool,
  }).isRequired,
  LoginStore: PropTypes.shape({
    isUserLoggedIn: PropTypes.bool,
    setloginModal: PropTypes.func.isRequired,
    logoutAction: PropTypes.func.isRequired,
  }).isRequired,
  class: PropTypes.string,
};

export default MobileAction;



// WEBPACK FOOTER //
// ./src/component/Header/MobileHeader/MobileActionButton/index.js